export default __webpack_public_path__ + "static/lilnadas-cards-health-1-a6a6b1ceb335ef634543b3664b85cb2f.png";